import { ExpressionRule } from "../../ExpressionRule";
import { ExpressionValue } from "../../ExpressionValue";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import { NumberDataDefinition } from "../../../Common/Data/Definitions/NumberDataDefinition";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class ModExpression extends ExpressionRule {
    readonly __type: string = "Mod";
    value1: ExpressionValue;
    value2: ExpressionValue;

    constructor() {
        super();

        this.expressionValueType = new NumberDataDefinition();
        let dd = new NumberDataDefinition();
        this.value1 = ExpressionValue.createExpressionValue(this, "value1", dd);

        dd = new NumberDataDefinition();
        this.value2 = ExpressionValue.createExpressionValue(this, "value2", dd);
    }

    evaluate(data: ExecutionData, testContext: ITestingContext | undefined): AppGlueAny {
        let divideValue = this.value1.evaluate(data, testContext);
        let divideBy = this.value2.evaluate(data, testContext);

        if (divideBy === 0) {
            throw new Error("Can not divide by zero");
        }

        return divideValue % divideBy;
    }
}
